import React, {useContext, useState, useEffect, useRef} from 'react';
import _ from "lodash";
import "./historyPaymentForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import Paper from '@material-ui/core/Paper';
import { DatePicker } from "@material-ui/pickers";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FixedHeaderTable from '../../components/FixedHeaderTable';
import moment from 'moment';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {PAYMENT_HISTORY_TEACHER, PAYMENT_HISTORY_STUDENT} from "../../utils/constants";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import * as yup from 'yup';
const useStyles = makeStyles({
    table: {
        minWidth: 450,
    },
});


const columns = [
    { id: 'name', label: 'Student Name', minWidth: 170 },
    {
        id: 'programLvl',
        label: 'Program Level',
        minWidth: 100
    },
    {
        id: 'icNo',
        label: 'NRIC No.',
        minWidth: 170,
        align: 'right',
        format: (value) => value.toLocaleString('en-US'),
    },
    {
        id: 'phoneNo',
        label: 'Phone No.',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: 170,
        align: 'right',
    },
];

const HistoryPaymentForm = () => {
    const classes = useStyles();
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { getAllMisc, getAllStudents, getAllTeachers } = actions.generalActions;
    const { showStudentDetailDialog, getPaymentHistory } = actions.paymentActions;
    const { paymentHistory } = state.paymentStates;
    const { studentDetailDialogVisible } = state.paymentStates;
    const { students, teachers } = state.generalStates;
    const [programLvl, setProgramLvl] = React.useState(null);
    const [type, setType] = React.useState(PAYMENT_HISTORY_STUDENT);
    const [studentName, setStudentName] = React.useState(null);

    useEffect(() => {
        getAllMisc();
        getAllStudents();
    }, []);

    const handleChange = (event) => {
        setProgramLvl(event.target.value);
    };

    const handleTypeChange = (event) => {
        if (type === event.target.value) {
            return;
        } else {
            getAllTeachers();
        }
        setType(event.target.value);

    };

    const handleNameChange = (event) => {
        setStudentName(event.target.value);
    };

    const onViewDetailClick = (uuid) => {
        showStudentDetailDialog(true);
        getPaymentHistory(type, uuid);
    };

    const handleClose = () => {
        showStudentDetailDialog(false);
    };

    const handleOkBtn = () => {
        showStudentDetailDialog(false);
    };

    const handleSearchButton = () => {
        getAllStudents(studentName, programLvl);
    };

    const getTotalAmount = (monthlyDetail) => {
        let totalAmount = 0;
        for (let i = 0; i < monthlyDetail.length; i ++){
            totalAmount += monthlyDetail[i].fee;
        }

        return `${parseFloat(totalAmount).toFixed(2)}`;
    }

    const renderTransaction = () => {
        if (paymentHistory.length === 0){
            return;
        }
        const groupedByMonth = _.groupBy(paymentHistory, function(item) {
            return item.transactionDate.substring(3,10);
        });

        let table = [];
        Object.keys(groupedByMonth).map(function(key, index) {
            const monthlyDetail = groupedByMonth[key];
            table.push(transactionDetail(monthlyDetail));
        });

        return table;
    };

    const getTransactionDate = (transactionDate) => {
        if (type === PAYMENT_HISTORY_STUDENT) {
            return moment(transactionDate, "DD-MM-YYYY").format("MMM YYYY");
        } else {
            return moment(transactionDate, "MM-YYYY").format("MMM YYYY");
        }
    }

    const transactionDetail = (monthlyDetail) => (
        <div>
            <h4 style={{marginTop: "10px"}}>{getTransactionDate(monthlyDetail[0].transactionDate)}</h4>
            <TableContainer component={Paper} style={{marginTop: "10px"}}>
                <Table className={classes.table} aria-label="spanning table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Name</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Transaction date</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Date created</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="right">Amount (RM)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {monthlyDetail.map((row) => (
                            <TableRow key={row.subjectName}>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.transactionDate}</TableCell>
                                <TableCell>{row.dateCreated}</TableCell>
                                <TableCell align="right">{row.fee}</TableCell>
                            </TableRow>
                        ))}

                        <TableRow>
                            <TableCell />
                            <TableCell />
                            <TableCell colSpan={1} align="right"><b>Total (RM)</b></TableCell>
                            <TableCell align="right"><b>{getTotalAmount(monthlyDetail)}</b></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )

    return (
        <div className="misc-student-payment-container">
            <h1 className="header">History</h1>
            <div className="paperContainer">
                <FormControl className="form-control">
                    <InputLabel id="program-lvl-label">Program level</InputLabel>
                    <Select
                        labelId="program-lvl-label"
                        value={programLvl}
                        onChange={handleChange}>
                        <MenuItem value={1}>Remove</MenuItem>
                        <MenuItem value={2}>Form 1</MenuItem>
                        <MenuItem value={3}>Form 2</MenuItem>
                        <MenuItem value={4}>Form 3</MenuItem>
                        <MenuItem value={5}>Form 4</MenuItem>
                        <MenuItem value={6}>Form 5</MenuItem>
                        <MenuItem value={8}>Form 5 (Graduated)</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className="form-control">
                    <InputLabel id="type-label">Type</InputLabel>
                    <Select
                        labelId="type-label"
                        value={type}
                        onChange={handleTypeChange}>
                        <MenuItem value={"STUDENT"}>Student</MenuItem>
                        <MenuItem value={"TEACHER"}>Teacher</MenuItem>
                    </Select>
                </FormControl>
                <TextField className="text-field" label="Name" onChange={handleNameChange}/>

                <Button className="search-btn" variant="contained" color="primary" onClick={handleSearchButton}>
                    Search
                </Button>

                <div className="table-container">
                    {<FixedHeaderTable columns={columns} rows={type === PAYMENT_HISTORY_STUDENT ? students : teachers} buttonContent="View Detail" buttonAction={onViewDetailClick}/>}
                </div>

            </div>

            <Dialog open={studentDetailDialogVisible} onClose={handleClose} aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth = {'md'}>
                <DialogTitle id="form-dialog-title"><h2>Payment Details</h2></DialogTitle>
                <DialogContent>
                    {renderTransaction()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleOkBtn} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>


        </div>
    )
}

export default withRouter(HistoryPaymentForm)
